export default "__VITE_ASSET__CMVLp6_E__"